/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import moment from 'moment';
import * as actionType from './actionTypes';
import * as Constants from '../../../../SharedModules/AppConstants';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
// Get all status searched values
export const selectionList = (data) => {
  return {
    type: actionType.SELECTION_TYPE_OPTIONS,
    payload: data,
  };
};
// Store all updated rebate program dropdown list
export const dropdownUpdatedList = (data) => {
  return {
    type: actionType.DROPDOWN_UPDATED_LIST,
    payload: data,
  };
};
// Reset to Initial State
export const resetStoreCMSInconsistencies = () => {
  return {
    type: actionType.RESET_INCONSISTENCIES_DATA,
  };
};
// Error messages handling in the store
export const handleErrorMessages = (data) => ({
  type: actionType.HANDLE_ERROR_MESSAGE,
  errorMessagesInRedux: data,
});
// handling dropdown rebate program values
export const dispatchCommonDropdownData = (data) => ({
  type: actionType.GET_COMMON_DROPDOWN_DATA_CI,
  dropdown: data,
});
// service to get all dropdown values
export const getCommonDropdownList = (value) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      //return dispatch(dispatchCommonDropdownData(response.data));
      return response.data;
    })
    .catch(() => {
      //  dispatch(dispatchCommonDropdownData([]));
      return [];
    });
};
// dispatch manufacturer grid data
export const dispatchManufacturerData = (data) => ({
  type: actionType.GET_MANUFACTURER_GRID_LIST,
  manufacturerList: data,
});
// service to get all manufacturer list
export const getManufacturerList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.MANUFACTURER_RPC_MTC, value)
    .then((response) => {
      if (response?.data?.response !== 'Record Not Found') {
        return dispatch(
          dispatchManufacturerData(
            response && response.data && response.data.response
          )
        );
      }

      const res = {
        status: '002',
        message: response?.data?.response,
      };
      return dispatch(dispatchManufacturerData(res));
    })
    .catch(() => {
      dispatch(dispatchManufacturerData([]));
    });
};
// store Max Quarter value
export const dispatchMaxQuarter = (data) => ({
  type: actionType.GET_MAX_QUARTER,
  payload: data,
});
export function incrementQuarter(str) {
  if (!str || typeof str !== 'string') return null;

  const parts = str.trim().toUpperCase().split('Q');
  if (parts.length !== 2) return null;

  const quarter = parseInt(parts[0], 10);
  const year = parseInt(parts[1], 10);
  if (isNaN(quarter) || isNaN(year)) return null;

  const total = (year * 4) + (quarter - 1) + 1;
  const newYear = Math.floor(total / 4);
  const newQuarter = (total % 4) + 1;

  return `${newQuarter}Q${newYear}`;
}


// service to get maximum quarter
export const getMaximumQuarter = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_MAXQUARTER_FOR_INVOICE}`, value)
    .then((response) => {
       const currentQuarter = response?.data?.data;
      const nextQuarter = incrementQuarter(currentQuarter);
      dispatch(dispatchMaxQuarter(nextQuarter))
     // return dispatch(dispatchMaxQuarter(response?.data?.data));
    })
    .catch((error) => {
      dispatch(dispatchMaxQuarter(error));
    });
};
// store header details
export const headerInconsistency = (data) => ({
  type: actionType.HEADER_INCONSISTENT_DETAILS,
  payload: data,
});
// store single header value
export const singleInconsistency = (data) => ({
  type: actionType.SINGLE_INCONSISTENT_DATA,
  payload: data,
});
// store status bit for navigation
export const statusBit = (data) => ({
  type: actionType.FLAG_NAVIGATION,
  payload: data,
});
// service to search inconsistency header
export const searchInconsistencyPayload = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SEARCH_INCONSISTENCY_HEADER}`, value)
    .then((response) => {
      if (response?.data?.response !== 'Record Not Found') {
        dispatch(statusBit(1));
        dispatch(headerInconsistency(response && response.data));
        return response?.data;
      }
      const res = {
        status: '002',
        message: response?.data?.response,
      };
      dispatch(headerInconsistency(res));
      return res;
    })
    .catch((error) => {
      return dispatch(headerInconsistency(null));
    });
};
// store header details
export const dispatchRosiMainGrid = (data) => ({
  type: actionType.ROSI_MAIN_GRID,
  payload: data,
});
// service to get ROSI Grid
export const getRosiGrid = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.ROSI_GRID}`, value)
    .then((result) => {
      const rosiRes = result?.data?.response;

      if (rosiRes?.length > 0) {
        const newObj = rosiRes?.map((item, index) => {
          item.ndc = `${item.labelerCode}-${item.productCode}-${item.packageSize}`;
          if (item.adjustedUnitRebateAmt) {
            const temp = parseFloat(item.adjustedUnitRebateAmt).toFixed(2);
            item.adjustedUnitRebateAmt = `$ ${temp}`;
          } else {
            const temp = parseFloat(0).toFixed(2);
            item.adjustedUnitRebateAmt = `$ ${temp}`;
          }

          if (item.invoiceCorrectionAmt) {
            const temp = parseFloat(item.invoiceCorrectionAmt).toFixed(2);
            item.invoiceCorrectionAmt = `$ ${temp}`;
          } else {
            const temp = parseFloat(0).toFixed(2);
            item.invoiceCorrectionAmt = `$ ${temp}`;
          }
          if (item.withheldInvoiceAmt) {
            const temp = parseFloat(item.withheldInvoiceAmt).toFixed(2);
            item.withheldInvoiceAmt = `$ ${temp}`;
          } else {
            const temp = parseFloat(0).toFixed(2);
            item.withheldInvoiceAmt = `$ ${temp}`;
          }
          if (item.paidAmt) {
            const temp = parseFloat(item.paidAmt).toFixed(2);
            item.paidAmt = `$ ${temp}`;
          } else {
            const temp = parseFloat(0).toFixed(2);
            item.paidAmt = `$ ${temp}`;
          }
          if (item.unitRebateAmt) {
            if (item.totReimbursedUnits) {
              const temp =
                parseInt(item.unitRebateAmt, [1, 1000]) *
                parseInt(item.totReimbursedUnits, [1, 1000]);
              item.rebateAmtInvoiced = parseFloat(temp).toFixed(2);
            } else {
              item.rebateAmtInvoiced = parseFloat(item.unitRebateAmt).toFixed(
                2
              );
            }

            item.unitRebateAmt = item.unitRebateAmt
              ? parseFloat(item.unitRebateAmt).toFixed(6)
              : parseFloat(0).toFixed(6);
          }

          if (item.tot_reimbursed_Units) {
            item.tot_reimbursed_Units = item.tot_reimbursed_Units
              ? parseFloat(item.tot_reimbursed_Units).toFixed(3)
              : parseFloat(0).toFixed(3);
          }

          item.disputedUnits = item.disputedUnits
            ? parseFloat(item.disputedUnits).toFixed(3)
            : parseFloat(0).toFixed(3);

          item.paidUnits = item.paidUnits
            ? parseFloat(item.paidUnits).toFixed(3)
            : parseFloat(0).toFixed(3);

          if (!item.adjustedUnits || item.adjustedUnits === null) {
            item.adjustedUnits = parseFloat(0).toFixed(2);
          }

          if (item.rebateAmtInvoiced) {
            const temp = parseFloat(item.rebateAmtInvoiced).toFixed(2);
            item.rebateAmtInvoiced = `$ ${temp}`;
          } else {
            const temp = parseFloat(0).toFixed(2);
            item.rebateAmtInvoiced = `$ ${temp}`;
          }
          return item;
        });

        return dispatch(dispatchRosiMainGrid(newObj));
      }
      return dispatch(dispatchRosiMainGrid([]));
    })
    .catch((error) => {
      return dispatch(dispatchRosiMainGrid([]));
    });
};
// store header details
export const dispatchPqasMainGrid = (data) => ({
  type: actionType.PQAS_MAIN_GRID,
  payload: data,
});
// service to get PQAS Grid
export const getPqasGrid = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.PQAS_GRID}`, value)
    .then((response) => {
      if (response?.data?.response !== 'Record Not Found') {
        const newObj = response?.data?.response?.map((item, index) => {
          item.ndc = `${item.labelerCode}-${item.productCode}-${item.packageSize}`;
          if (item.orignalInvoiceAmt) {
            const temp = parseFloat(item.orignalInvoiceAmt).toFixed(2);
            // const temp =
            //   item.orignalInvoiceAmt % 1 !== 0
            //     ? item.orignalInvoiceAmt.toFixed(2)
            //     : item.orignalInvoiceAmt.toFixed(2);
            item.orignalInvoiceAmt = `$ ${temp}`;
          } else {
            const temp = parseFloat(0).toFixed(2);
            item.orignalInvoiceAmt = `$ ${temp}`;
          }
          if (item.revisedInvoiceAmt) {
            const temp = parseFloat(item.revisedInvoiceAmt).toFixed(2);
            // const temp =
            //   item.revisedInvoiceAmt % 1 !== 0
            //     ? item.revisedInvoiceAmt.toFixed(2)
            //     : item.revisedInvoiceAmt.toFixed(1);
            item.revisedInvoiceAmt = `$ ${temp}`;
          } else {
            const temp = parseFloat(0).toFixed(2);
            item.revisedInvoiceAmt = `$ ${temp}`;
          }
          if (item.priorPaidAmt) {
            const temp = parseFloat(item.priorPaidAmt).toFixed(2);
            // const temp =
            //   item.priorPaidAmt % 1 !== 0
            //     ? item.priorPaidAmt.toFixed(2)
            //     : item.priorPaidAmt.toFixed(1);
            item.priorPaidAmt = `$ ${temp}`;
          } else {
            const temp = parseFloat(0).toFixed(2);
            item.priorPaidAmt = `$ ${temp}`;
          }
          if (item.currAmtPaid) {
            const temp = parseFloat(item.currAmtPaid).toFixed(2);
            // const temp =
            //   item.currAmtPaid % 1 !== 0
            //     ? item.currAmtPaid.toFixed(2)
            //     : item.currAmtPaid.toFixed(1);
            item.currAmtPaid = `$ ${temp}`;
          } else {
            const temp = parseFloat(0).toFixed(2);
            item.currAmtPaid = `$ ${temp}`;
          }
          if (item.paidThisTransactionAmt) {
            const temp = parseFloat(item.paidThisTransactionAmt).toFixed(2);
            // const temp =
            //   item.paidThisTransactionAmt % 1 !== 0
            //     ? item.paidThisTransactionAmt.toFixed(2)
            //     : item.paidThisTransactionAmt.toFixed(1);
            item.paidThisTransactionAmt = `$ ${temp}`;
          } else {
            const temp = parseFloat(0).toFixed(2);
            item.paidThisTransactionAmt = `$ ${temp}`;
          }

          item.currUnitRebateAmt = item.currUnitRebateAmt
            ? parseFloat(item.currUnitRebateAmt).toFixed(6)
            : parseFloat(0).toFixed(6);

          item.currUnits = item.currUnits
            ? parseFloat(item.currUnits).toFixed(3)
            : parseFloat(0).toFixed(3);

          item.priorPaidUnits = item.priorPaidUnits
            ? parseFloat(item.priorPaidUnits).toFixed(3)
            : parseFloat(0).toFixed(3);

          item.currUnitsPaid = item.currUnitsPaid
            ? parseFloat(item.currUnitsPaid).toFixed(3)
            : parseFloat(0).toFixed(3);

          item.priorDisputedUnits = item.priorDisputedUnit
            ? parseFloat(item.priorDisputedUnits).toFixed(3)
            : parseFloat(0).toFixed(3);

          item.currUnitsDisputed = item.currUnitsDisputed
            ? parseFloat(item.currUnitsDisputed).toFixed(3)
            : parseFloat(0).toFixed(3);

          return item;
        });
        return dispatch(dispatchPqasMainGrid(newObj));
      }
      return dispatch(dispatchPqasMainGrid([]));
    })
    .catch((error) => {
      return dispatch(dispatchPqasMainGrid([]));
    });
};
// store dropdown quarter data
export const previousDataQtr = (data) => ({
  type: actionType.QUARTER_DATA_PQAS,
  payload: data,
});
// service to get previous quarter data
export const getPreviousQuarterData = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.PREVIOUS_QTR_PQAS}`, value)
    .then((response) => {
      if (response?.data?.response !== 'Record Not Found') {
        return dispatch(
          previousDataQtr(response.data && response.data.response)
        );
      }
      return dispatch(previousDataQtr([]));
    })
    .catch((error) => {
      return dispatch(previousDataQtr([]));
    });
};
// store view details Rosi Data
export const detailShowRosiData = (data) => ({
  type: actionType.DETAIL_ROSI_DATA,
  payload: data,
});
// store view details Pqas Data
export const detailShowPqasData = (data) => ({
  type: actionType.DETAIL_PQAS_DATA,
  payload: data,
});
// service to get view details data
export const getViewDetailInconsistency = (value, flag) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.Inconsistency_DESC}`, value)
    .then((response) => {
      if (response.data.response !== 'Record Not Found') {
        if (flag === 0) {
          return dispatch(detailShowRosiData(response.data.response[0]));
        }
        if (flag === 1) {
          return dispatch(detailShowPqasData(response.data.response[0]));
        }
      }
    })
    .catch((error) => {
      dispatch(detailShowRosiData(null));
      return dispatch(detailShowPqasData(null));
    });
};

// handling tabValue
export const dispatchTabValue = (data) => ({
  type: actionType.TAB_VALUE,
  payload: data,
});
export const clearReduxForRosiInconsistencies = () => (dispatch) => {
  dispatch(dispatchManufacturerData([]));
  dispatch(selectionList(''));
  dispatch(handleErrorMessages({}));
  dispatch(dispatchMaxQuarter(''));
  dispatch(headerInconsistency({}));
  dispatch(statusBit());
  dispatch(dropdownUpdatedList([]));
};
export const clearReduxForRosiInconsistenciesDetail = () => (dispatch) => {
  dispatch(selectionList(''));
  dispatch(handleErrorMessages({}));
  dispatch(headerInconsistency([]));
  dispatch(singleInconsistency({}));
  dispatch(dispatchRosiMainGrid([]));
  dispatch(dispatchPqasMainGrid([]));
  dispatch(previousDataQtr(''));
  dispatch(detailShowRosiData([]));
  dispatch(detailShowPqasData([]));
  dispatch(dispatchTabValue(''));
};
